import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useRef, useEffect } from 'react';
import { AnchoredOverlay } from '@primer/react';
import LTIconButton from '../LTIconButton/index.js';
import LTButton from '../LTButton/index.js';
import TriangleDownIcon from '../../icons/TriangleDownIcon.js';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Component for creating an overlay which will be attached to a button.
 * @param {!Element} children DOM Element for rendering overlay content.
 * @param {string} buttonVariant The variant of the button to render.
 * @param {function} iconComponent The icon to be rendered on button.
 * @param {boolean} size The size of the chip.
 */
var LTAnchoredOverlay = function LTAnchoredOverlay(_a) {
  var _b = _a.anchorType,
    anchorType = _b === void 0 ? LTAnchoredOverlay.AnchorType.ICONBUTTON : _b,
    _c = _a.anchorButtonType,
    anchorButtonType = _c === void 0 ? undefined : _c,
    _d = _a.align,
    align = _d === void 0 ? LTAnchoredOverlay.Align.START : _d,
    _e = _a.ariaLabel,
    ariaLabel = _e === void 0 ? undefined : _e,
    _f = _a.anchorId,
    anchorId = _f === void 0 ? undefined : _f,
    _g = _a.buttonVariant,
    buttonVariant = _g === void 0 ? LTIconButton.IconButtonVariants.DEFAULT : _g,
    children = _a.children,
    customComponent = _a.customComponent,
    _h = _a.closeOverlay,
    closeOverlay = _h === void 0 ? false : _h,
    customStyle = _a.customStyle,
    customPanelButtonSize = _a.customPanelButtonSize,
    iconComponent = _a.iconComponent,
    onBackdropClick = _a.onBackdropClick,
    tabIndex = _a.tabIndex,
    title = _a.title,
    side = _a.side,
    _j = _a.buttonClassName,
    buttonClassName = _j === void 0 ? "" : _j;
  var _k = useState(false),
    open = _k[0],
    setOpen = _k[1];
  var btnRef = useRef();
  // to close the overlay explicitly
  useEffect(function () {
    if (closeOverlay) {
      setOpen(false);
    }
  }, [closeOverlay]);
  useEffect(function () {
    if (open) {
      setTimeout(function () {
        var elems = document.getElementsByClassName("sentinel");
        for (var i = 0; i < (elems === null || elems === void 0 ? void 0 : elems.length); i++) {
          elems[i].setAttribute("tabindex", "-1");
        }
      }, 0);
    }
  }, [open]);
  return /*#__PURE__*/React.createElement(AnchoredOverlay, {
    align: align,
    anchorRef: btnRef,
    open: open,
    onOpen: function onOpen() {
      setOpen(true);
    },
    onClose: function onClose() {
      setOpen(false);
      if (onBackdropClick && open) {
        onBackdropClick();
      }
    },
    id: anchorId,
    renderAnchor: function renderAnchor(props) {
      var _assign;
      return customComponent ? /*#__PURE__*/React.createElement("div", __assign({}, props, {
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": open ? anchorId : undefined,
        tabIndex: -1
      }), customComponent) : anchorType === LTAnchoredOverlay.AnchorType.BUTTON ? /*#__PURE__*/React.createElement(LTButton, __assign((_assign = {
        ariaLabel: ariaLabel,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": open ? anchorId : undefined,
        forwardRef: props.ref,
        variant: LTButton.Variant.DEFAULT,
        trailingIcon: /*#__PURE__*/React.createElement(TriangleDownIcon, null),
        size: customPanelButtonSize,
        style: {
          backgroundColor: "bg.muted",
          borderColor: "border.default"
        }
      }, _defineProperty(_assign, "style", customStyle), _defineProperty(_assign, "tabIndex", tabIndex), _defineProperty(_assign, "className", buttonClassName), _defineProperty(_assign, "type", anchorButtonType), _assign), props), title) : /*#__PURE__*/React.createElement(LTIconButton, __assign({
        "aria-label": ariaLabel,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": open ? anchorId : undefined,
        ref: btnRef,
        icon: iconComponent,
        size: LTIconButton.Size.SMALL,
        variant: buttonVariant,
        customStyle: customStyle,
        type: anchorButtonType
      }, props));
    },
    side: side
  }, children);
};
LTAnchoredOverlay.Side = {
  INSIDE_TOP: "inside-top",
  INSIDE_BOTTOM: "inside-bottom",
  INSIDE_LEFT: "inside-left",
  INSIDE_RIGHT: "inside-right",
  INSIDE_CENTER: "inside-center",
  OUTSIDE_TOP: "outside-top",
  OUTSIDE_BOTTOM: "outside-bottom",
  OUTSIDE_LEFT: "outside-left",
  OUTSIDE_RIGHT: "outside-right"
};
LTAnchoredOverlay.AnchorType = {
  ICONBUTTON: "iconButton",
  BUTTON: "button"
};
LTAnchoredOverlay.Align = {
  START: "start",
  CENTER: "center",
  END: "end"
};

export { LTAnchoredOverlay as default };
